import type { ReactNode } from "react";
import React, { createContext, useContext } from "react";

import type {
  ClickHtmlDatameshEvent,
  ComponentDisplayHtmlDatameshEvent,
  DataMeshTracker,
} from "../html_event/types";

type TransactionIDSetter = (id: string) => void;

export interface DataMeshTrackingClient {
  trackClick: DataMeshTracker<ClickHtmlDatameshEvent>;
  trackComponentDisplayed: DataMeshTracker<ComponentDisplayHtmlDatameshEvent>;
  setTransactionBookingId: TransactionIDSetter;
  setTransactionSearchId: TransactionIDSetter;
  setTransactionMembershipId: TransactionIDSetter;
}

interface DataMeshTrackingProviderProps {
  dataMeshTrackingClient: DataMeshTrackingClient;
  children: ReactNode;
}

const dataMeshTrackingClient: DataMeshTrackingClient = {
  trackClick: (() => {}) as DataMeshTrackingClient["trackClick"],
  trackComponentDisplayed:
    (() => {}) as DataMeshTrackingClient["trackComponentDisplayed"],
  setTransactionBookingId: () => {},
  setTransactionSearchId: () => {},
  setTransactionMembershipId: () => {},
};

const dataMeshTrackingContext = createContext<DataMeshTrackingClient>(
  dataMeshTrackingClient,
);

export const useDataMeshTracking = () => useContext(dataMeshTrackingContext);
export const useUpdateDataMeshTransactionId = () => {
  const {
    setTransactionBookingId,
    setTransactionSearchId,
    setTransactionMembershipId,
  } = useContext(dataMeshTrackingContext);
  return {
    setTransactionBookingId,
    setTransactionSearchId,
    setTransactionMembershipId,
  };
};

export const DataMeshTrackingProvider = ({
  dataMeshTrackingClient,
  children,
}: DataMeshTrackingProviderProps) => (
  <dataMeshTrackingContext.Provider value={dataMeshTrackingClient}>
    {children}
  </dataMeshTrackingContext.Provider>
);
